import cn from 'bem-cn';

import { CONDITIONS_URL, RoutePaths } from '../../../constants';

import './ChallengeInfoRules.scss';

const b = cn('challenge-info-rules');

export const ChallengeInfoRules = () => {
    return (
        <p className={b()}>
            Нажимая кнопку «Принимаю челлендж!», я соглашаюсь с условиями участия в конкурсе{' '}
            <a
                href={`https://${window.location.hostname}/prompthub${RoutePaths.CompeteRules}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                «ИИ-челленджи на платформе Промптхаб»{' '}
            </a>
            и принимаю{' '}
            <a href={CONDITIONS_URL} target="_blank" rel="noopener noreferrer">
                условия использования сервиса
            </a>
        </p>
    );
};
